import Github from './Github';
import Issues from './Issues';
import Size from './Size';
import Activity from './Activity';
import Downloads from './Downloads';

Github.Issues = Issues;
Github.Size = Size;
Github.Activity = Activity;
Github.Downloads = Downloads;

export default Github;